import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/auth';

export function useAuthRedirect(redirectTo = '/dashboard', requireAuth = true) {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (requireAuth && currentUser) {
      // User is authenticated, redirect to dashboard
      navigate(redirectTo);
    } else if (!requireAuth && !currentUser) {
      // User is not authenticated, redirect to login
      navigate('/login');
    }
  }, [currentUser, navigate, redirectTo, requireAuth]);

  return { currentUser };
} 